import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import "./ChatList.css";

function  ChatList() {
  const [searchQuery, setSearchQuery] = useState("");
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [decodedToken, setDecodedToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      try {
        const decoded = jwtDecode(storedToken);
        setDecodedToken(decoded);
        // console.log('Decoded token:', decoded);
      } catch (error) {
        console.error('Error decoding token:', error);
        setError('Invalid token');
      }
    }
  }, []);

  useEffect(() => {
    if (token) {
      fetchChats();
    }
  }, [token]);

  const fetchChats = async () => {
    setLoading(true);
    setError(null);
    try {
      let response
      if (decodedToken.rolename === "Admin") {
        response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chats`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else if (decodedToken.rolename === "Tutor") {
        response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chats-tutor`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      // response = await axios.get(
      //   `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chats`,
      //   {
      //     headers: { Authorization: `Bearer ${token}` },
      //   }
      // );

      // console.log("Response received:", response?.data);

      const formattedChats = response?.data?.data.map((chat1) => {
        const lastMessageObj = chat1?.chat?.length
          ? chat1.chat[chat1.chat.length - 1]
          : null;

        return {
          id: chat1?._id,
          name: chat1?.userDetails?.user_name,
          batch_name: chat1?.batchDetails?.batch_name,
          imgg: chat1?.userDetails?.profile_url,
          lastMessage: lastMessageObj
            ? lastMessageObj.message
            : "No messages yet",
          time: lastMessageObj
            ? new Date(lastMessageObj.timestamp).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            : "N/A",
          unread: chat1.unread || false, // Assuming unread exists in API
        };
      });

      setChats(formattedChats);
    } catch (error) {
      console.error("Failed to fetch chats:", error);
      setError("Failed to fetch chats.");
    } finally {
      setLoading(false);
    }
  };

  const filteredChats = chats.filter((chat1) =>
    chat1?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  return (
    <div className="chat-list">
      <div className="search-bar bg-base">
        <input className="bg-base"
          type="text"
          placeholder="Search Names..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      {loading ? (
        <p>Loading chats...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : filteredChats.length === 0 ? (
        <div className="no-chats">
          <p className="text-center text-secondary-light py-3">No chats available</p>
        </div>
      ) : (
        filteredChats.map((chat) => (
          <div
            key={chat?.id}
            className="chat-item"
            onClick={() => navigate(`/chat-view`, { state: { chat } })}
          >
            <div className="profile-image">
              <div className="avatar">
                {chat?.imgg ? (
                  <img src={chat?.imgg} alt="Profile" />
                ) : (
                  chat?.name[0] // No extra `{}` needed
                )}
              </div>
            </div>
            <div className="chat-info">
              <div className="chatViewHead">
                <div className="chat-name">
                {chat?.name.toUpperCase()}
                  {chat?.unread && <div className="unread-indicator" />}
                </div>
                <span className="time">
                  {chat?.batch_name ? `( ${chat?.batch_name} )` : ''} {chat?.time}
                </span>
              </div>
              <p className="last-message">{chat?.lastMessage}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default ChatList;
